import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import bg from '../../assets/images/error_bg.png';
import lightning from '../../assets/images/lightning.png';

const StyledContainer = styled.div`
	position: fixed;
	top: 21px;
	left: 22px;
	width: 1020px;
	height: 680px;
	z-index: 25;
	border-radius: 30px;
	background-image: url(${bg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	transition: opacity 0.3s;
	opacity: 0;
	overflow: hidden;

	&.overlay-enter {
		opacity: 0;
	}

	&.overlay-enter-active,
	&.overlay-enter-done,
	&.overlay-exit {
		opacity: 1;
	}

	&.overlay-exit-active {
		opacity: 0;
	}
`;

const StyledLightning = styled.div<{
	$position: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
}>`
	position: absolute;
	width: 508px;
	height: 499px;
	background-image: url(${lightning});
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	transition: transform 0.3s ease-in-out;

	${({ $position }) => {
		switch ($position) {
			case 'topLeft':
				return `
                    top: -400px;
                    left: -400px;
                    transform: translate(-400px, -400px) scaleX(1);
                    
                    .overlay-enter & {
                        transform: translate(-400px, -400px) scaleX(1);
                    }
                    
                    .overlay-enter-active &,
                    .overlay-enter-done &,
                    .overlay-exit & {
                        transform: translate(190px, 220px) scaleX(1);
                    }
                    
                    .overlay-exit-active & {
                        transform: translate(-400px, -400px) scaleX(1);
                    }
                `;
			case 'topRight':
				return `
                    top: -400px;
                    right: -400px;
                    transform: translate(400px, -400px) scaleX(-1);
                    
                    .overlay-enter & {
                        transform: translate(400px, -400px) scaleX(-1);
                    }
                    
                    .overlay-enter-active &,
                    .overlay-enter-done &,
                    .overlay-exit & {
                        transform: translate(-190px, 220px) scaleX(-1);
                    }
                    
                    .overlay-exit-active & {
                        transform: translate(400px, -400px) scaleX(-1);
                    }
                `;
			case 'bottomLeft':
				return `
                    bottom: -400px;
                    left: -400px;
                    transform: translate(-400px, 400px) scaleX(1) scaleY(-1);
                    
                    .overlay-enter & {
                        transform: translate(-400px, 400px) scaleX(1) scaleY(-1);
                    }
                    
                    .overlay-enter-active &,
                    .overlay-enter-done &,
                    .overlay-exit & {
                        transform: translate(190px, -220px) scaleX(1) scaleY(-1);
                    }
                    
                    .overlay-exit-active & {
                        transform: translate(-400px, 400px) scaleX(1) scaleY(-1);
                    }
                `;
			case 'bottomRight':
				return `
                    bottom: -400px;
                    right: -400px;
                    transform: translate(400px, 400px) scaleX(-1) scaleY(-1);
                    
                    .overlay-enter & {
                        transform: translate(400px, 400px) scaleX(-1) scaleY(-1);
                    }
                    
                    .overlay-enter-active &,
                    .overlay-enter-done &,
                    .overlay-exit & {
                        transform: translate(-190px, -220px) scaleX(-1) scaleY(-1);
                    }
                    
                    .overlay-exit-active & {
                        transform: translate(400px, 400px) scaleX(-1) scaleY(-1);
                    }
                `;
		}
	}}
`;

const StyledErrorText = styled(Text)`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-weight: 700;
	font-size: 20px;
	letter-spacing: 0.4em;
	color: #ffffff;
`;

const StyledBottomText = styled(Text)`
	position: absolute;
	left: 50%;
	bottom: 40px;
	transform: translateX(-50%);
	font-size: 12px;
	color: #ffffff;
	opacity: 0.1;
`;

export { StyledBottomText, StyledContainer, StyledErrorText, StyledLightning };
